<script lang="ts">
	import { groupColor } from './group/pricingGroupColor'
	import { MembershipsV1BillingCycle } from '@sdk/Api'

	interface Props {
		billingCycle: MembershipsV1BillingCycle
		variant: string
	}

	let { billingCycle = $bindable(), variant }: Props = $props()

	let className = $derived(
		billingCycle === MembershipsV1BillingCycle.BILLING_CYCLE_MONTHLY
			? groupColor[variant]?.transparent
			: groupColor[variant]?.selected,
	)
</script>

<div class="rounded-lg p-1 whitespace-nowrap max-md:text-xs {className}">
	<div class="relative">
		<div
			class="shadow-basic-new pointer-events-none absolute h-full w-1/2 rounded-md bg-white transition-transform {billingCycle ===
			MembershipsV1BillingCycle.BILLING_CYCLE_MONTHLY
				? 'translate-x-0'
				: 'translate-x-full'}"
		></div>
		<div class="relative grid grid-cols-2 gap-2">
			<button
				class="rounded-md px-2.5 py-1 text-center transition-colors hover:bg-white/30 {billingCycle ===
				MembershipsV1BillingCycle.BILLING_CYCLE_MONTHLY
					? 'text-dark'
					: ''}"
				onclick={() => (billingCycle = MembershipsV1BillingCycle.BILLING_CYCLE_MONTHLY)}
			>
				Monthly
			</button>
			<button
				class="rounded-md px-2.5 py-1 text-center font-bold transition-colors hover:bg-white/30 {billingCycle ===
				MembershipsV1BillingCycle.BILLING_CYCLE_ANNUAL
					? 'text-dark'
					: ''}"
				onclick={() => (billingCycle = MembershipsV1BillingCycle.BILLING_CYCLE_ANNUAL)}
			>
				Yearly
			</button>
		</div>
	</div>
</div>
